/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimFormGeoCountry } from './ClaimFormGeoCountry';
import {
    ClaimFormGeoCountryFromJSON,
    ClaimFormGeoCountryFromJSONTyped,
    ClaimFormGeoCountryToJSON,
} from './ClaimFormGeoCountry';

/**
 * 
 * @export
 * @interface ClaimFormGeoDataResponse
 */
export interface ClaimFormGeoDataResponse {
    /**
     * 
     * @type {Array<ClaimFormGeoCountry>}
     * @memberof ClaimFormGeoDataResponse
     */
    countries: Array<ClaimFormGeoCountry>;
}

/**
 * Check if a given object implements the ClaimFormGeoDataResponse interface.
 */
export function instanceOfClaimFormGeoDataResponse(value: object): value is ClaimFormGeoDataResponse {
    if (!('countries' in value) || value['countries'] === undefined) return false;
    return true;
}

export function ClaimFormGeoDataResponseFromJSON(json: any): ClaimFormGeoDataResponse {
    return ClaimFormGeoDataResponseFromJSONTyped(json, false);
}

export function ClaimFormGeoDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFormGeoDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'countries': ((json['countries'] as Array<any>).map(ClaimFormGeoCountryFromJSON)),
    };
}

export function ClaimFormGeoDataResponseToJSON(value?: ClaimFormGeoDataResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countries': ((value['countries'] as Array<any>).map(ClaimFormGeoCountryToJSON)),
    };
}

